import { render, staticRenderFns } from "./orderCheckField.vue?vue&type=template&id=0a803b6c&scoped=true&"
import script from "./orderCheckField.vue?vue&type=script&lang=js&"
export * from "./orderCheckField.vue?vue&type=script&lang=js&"
import style0 from "./orderCheckField.vue?vue&type=style&index=0&id=0a803b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a803b6c",
  null
  
)

export default component.exports